/* models/tickers/basic_ticker */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var adaptive_ticker_1 = require(224) /* ./adaptive_ticker */;
    var BasicTicker = /** @class */ (function (_super) {
        tslib_1.__extends(BasicTicker, _super);
        function BasicTicker(attrs) {
            return _super.call(this, attrs) || this;
        }
        BasicTicker.__name__ = "BasicTicker";
        return BasicTicker;
    }(adaptive_ticker_1.AdaptiveTicker));
    exports.BasicTicker = BasicTicker;
}
